import type { ReactNode } from "react";

interface ReportSectionProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  action?: ReactNode;
}

export function ReportSection({
  title,
  subtitle,
  children,
  action,
}: ReportSectionProps) {
  return (
    <div
      className="rounded-xl border bg-white p-4"
      style={{ borderColor: "hsl(210,30%,85%)" }}
    >
      <div className="mb-3 flex items-center justify-between gap-2">
        <div>
          <h3 className="text-[14px] font-semibold tracking-tight">{title}</h3>
          {subtitle && (
            <div className="text-[12px] text-muted-foreground">{subtitle}</div>
          )}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
